import instance from './axiosConfig';

export default {
    get: function (url:any, data:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'get',
            params: data
        });
    },
    post: function (url:any, data:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    post1: function (url:any, data:any,headers:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'post',
            data: data,
            headers
        });
    },
    postsign: function (url:any, data:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
    },
    put: function (url:any, data:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'put',
            data: data
        });
    },
    delete: function (url:any, data:any) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'delete',
            params: data
        });
    },
    patch: function (url, data) {
        return instance({
            url: url, // 假地址 自行替换
            method: 'patch',
            data: data
        });
    },
}
